import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=a0b697a6&scoped=true&"
import script from "./NotificationSetting.vue?vue&type=script&lang=js&"
export * from "./NotificationSetting.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSetting.vue?vue&type=style&index=0&id=a0b697a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b697a6",
  null
  
)

export default component.exports